//import VueKeycloakJs from '@dsb-norge/vue-keycloak-js'
import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import { store } from './_store';
import vuetify from './plugins/vuetify'
import axios from 'axios';


import { App as CapacitorApp } from '@capacitor/app';
// import URLOpenListenerEvent from '@capacitor/app';

// import { authHeader } from "./_helpers"

import frenapi from "./_services/api.service";

const printerapi = axios.create({
   // baseURL: 'http://192.168.178.27:8000',
   baseURL: 'http://localhost:8000',
});


Vue.config.productionTip = false;
// Vue.prototype.$apiulr = "http://localhost:8999/"
// const frenapi = axios.create({
//     baseURL: "http://10.0.10.43:8999",
//     });
//

Vue.prototype.$api = frenapi;
Vue.prototype.$printerapi = printerapi;

export {frenapi};


// Add a 401 response interceptor
/* frenapi.interceptors.response.use(function (response) {
    return response;
}, function (error) {
    console.log(error)
    if (401 === error.response.status) {
        swal.fire({
          icon: 'warning',
          title: 'Oops...',
          text: 'Η συνεδρεία έχει λήξει!',
         // footer: '<a href="">Why do I have this issue?</a>'
         confirmButtonText: "Σύνδεση",
        }).then((result)=> {
            if (result.isConfirmed)
            window.location = '/login';
        });
    } else {
        return Promise.reject(error);
    }
});

*/


var vueStore = {
  customer: {Vehicles: [], Invoices: []},
  supplier: {},
  cid: '',
  customers: null,
  invoices_due: {},
  vehicleMakes:['Truck', 'Van', 'Bus', 'Trailer', 'PickUp', 'Box', 'Refrigerator', 'Tanker', 'Crane', 'Car', 'Garbage Pickup', 'Dump Truck', 'Flatbed', 'Ambulance', 'Tow', 'Mixer', 'Tractor', 'Forklift', 'Excavator']
};


const vehicleBadges = {
  "Truck": "mdi-truck",
  "Dump Truck": "mdi-dump-truck",
  "Garbage Pickup": "mdi-dump-truck",
  "Tow": "mdi-tow-truck",
  "Tanker": "mdi-tanker-truck",
  "Flatbed": "mdi-truck-flatbed",
  "Box": "mdi-truck",
  "Ambulance": "mdi-ambulance",
  "Van": "mdi-van-utility",
  "Crane": "mdi-tow-truck",
  "Trailer": "mdi-truck-trailer",
  "Tractor": "mdi-tractor",
  "Refrigerator": "mdi-truck-snowflake",
  "Mixer": "mdi-truck",
  "Forklift": "mdi-forklift",
  "Bus": "mdi-bus-side",
  "Car": "mdi-car-side",
  "Excavator": "mdi-excavator",
}


import services from "./assets/services.json"

import manfjson from "./assets/manufacturers.json"

const manufacturers  = manfjson

function tocurr(value) {
    return new Intl.NumberFormat("el-GR", {
      style: "currency",
      currency: "EUR",
    }).format(value.toFixed(2));
  }

function fmtDate(value) {
    const d = new Date(Date.parse(value));
    return d.toLocaleString('el-GR', {
      hour12: false });
  }

  function sumField(items, key) {
    // sum data in give key (property)
    return items.reduce((a, b) => a + (b[key] || 0), 0);
}

Vue.prototype.$vehicleBadges = vehicleBadges;
Vue.prototype.$store = vueStore;
Vue.prototype.$tocurr = tocurr;
Vue.prototype.$sumField = sumField;
Vue.prototype.$fmtDate = fmtDate;
Vue.prototype.$manufacturers = manufacturers;
Vue.prototype.$services = services;


CapacitorApp.addListener('backButton', ({canGoBack}) => {
  if(!canGoBack){
    CapacitorApp.exitApp();
  } else {
    window.history.back();
  }
});

CapacitorApp.addListener('appUrlOpen', ({url}) => {
  // Example url: fm://pro/tabs/tabs2
  // slug = /tabs/tabs2
  const slug = url.split('/pro').pop();

  // We only push to the route if there is a slug present
  if (slug) {
    router.push({
      path: slug,
    });
  }
});

// Vue.use(VueKeycloakJs, {
//   logout: {
//     redirectUri: `${process.env.VUE_APP_BASE_URL}` // Your home page
//   },
//   init: {
//     onLoad: 'check-sso', // 'login-required' or 'check-sso' if you only want to protect some routes
//     pkceMethod: 'S256',
//     enableLogging: false // set to true for debugging
//   },
//   config: {
//     url: `${process.env.VUE_APP_OIDC_URL}`, // https://sso.example.com/auth/
//     clientId: `${process.env.VUE_APP_OIDC_CLIENT_ID}`, // frontend-client-id
//     realm: `${process.env.VUE_APP_OIDC_REALM}` // example-realm
//   },
//   onInitError: () => {
//     console.log('Error Loading Auth')
//   }
// })

new Vue({
  router,
  vuetify,
  store,
  render: h => h(App),
}).$mount('#app')
